// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3nGLO","inputWrap":"styles_inputWrap__1vGqr","input":"styles_input__2yHpE"};